import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AssociationProvider } from './contexts/AssociationContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AssociationProvider>
      <App />
    </AssociationProvider>
  </React.StrictMode>
);
